module.exports = __webpack_public_path__ + "static/media/242 Park - Exterior Draft 1.f55bdbf2.jpg";